import { useEffect, useState } from "react";
import { Spin, Input, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Space, Table } from "antd";
import {
  CompletedCaseStatus,
  DeleteIconRed,
  EyeIcon,
  PencilIcon,
  PendingCaseStatus,
  UploadFilesRed,
} from "icons";
import { useNavigate } from "react-router-dom";
import { UseApiCallV2, useDebounce, UseLazyApiCallV2 } from "hooks";
import { ConfirmationPopUp } from "pages/cases-detail/components/modals";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import {
  dateTimeFormatted,
  getDatatableWidth,
  getFilterArrOnSearch,
} from "utils/helpers";
import moment from "moment";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { SwitchCasesList } from "icon-components/switchCasesList";

export const NotesTable = ({
  userSearch,
  notes,
  isLoading,
  onEditNote,
  refetchNotes,
  collapseOpen,
  handleDeleteNote,
  deleteNoteLoading,
}) => {
  const { translator } = useLanguageTranslator();
  const notesTableTrans = translator("caseDetail.notesTable");
  const columnsTrans = translator("casesTable.tableColumnsLabel");
  const { user } = useCurrentUserContext();
  const navigate = useNavigate();

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(14);

  function handlePagination(data) {
    setPageSize(data?.pageSize);
    setCurrentPage(data.current);
  }

  useEffect(() => {
    setCurrentPage(1);
    setPageSize(14);
  }, [window.location.pathname]);

  const columns = [
    {
      title: columnsTrans.number,
      dataIndex: "key",
      key: "key",
      render: (text, record, index) => {
        const globalIndex = ((currentPage || 1) - 1) * pageSize + index + 1;
        return index < 9 && currentPage === 1 ? `${index + 1}` : globalIndex;
      },
      width: "4%",
      align: "center",
    },
    {
      title: notesTableTrans.title,
      dataIndex: "title",
      key: "title",
      width: "8%",
      ellipsis: true,
    },
    {
      title: notesTableTrans.customerName,
      dataIndex: "name",
      key: "name",
      width: "9%",
      ellipsis: true,
      sorter: (a, b) => (a?.name ?? "").localeCompare(b?.name ?? ""),
    },
    {
      title: notesTableTrans.relation,
      dataIndex: "recipient",
      key: "recipient",
      width: "9%",
      sorter: (a, b) => (a?.recipient ?? "").localeCompare(b?.recipient ?? ""),
    },
    {
      title: notesTableTrans.createdBy,
      dataIndex: "loggedUser",
      key: "loggedUser",
      width: "9%",
      ellipsis: true,
      sorter: (a, b) =>
        (a?.loggedUser ?? "").localeCompare(b?.loggedUser ?? ""),
    },

    {
      title: notesTableTrans.createdAt,
      dataIndex: "createdAt",
      key: "createdAt",
      width: "9%",
      render: (value, record) => {
        return dateTimeFormatted(value);
      },
      sorter: (a, b) => {
        const timeA =
          a.createdAt === "None" ? 0 : moment(a.createdAt).valueOf();
        const timeB =
          b.createdAt === "None" ? 0 : moment(b.createdAt).valueOf();
        return timeA - timeB; // oldest → latest, click again for reverse
      },
    },
    {
      title: notesTableTrans.attachedFiles,
      dataIndex: "attachmentCount",
      key: "attachmentCount",
      width: "9%",
      align: "center",
    },

    // {
    //   title: notesTableTrans.detail,
    //   dataIndex: "detail",
    //   key: "detail",
    //   width: "9%",
    //   render: (value, record) => {
    //     return (
    //       <div
    //         title={value?.replace(/<[^>]+>/g, "")}
    //         dangerouslySetInnerHTML={{ __html: value }}
    //         className={styles.detail}
    //       ></div>
    //     );
    //   },
    // },

    {
      title: columnsTrans.action,
      key: notesTableTrans.action,
      width: "4%",
      align: "center",
      render: (_, record) => (
        <Space size="middle">
          <div style={{ display: "flex", gap: "5px" }}>
            <button className={styles.viewDetailsBtn}>
              <EyeIcon
                style={{ height: "13px", width: "13px" }}
                onClick={() => onEditNote(record)}
              />
            </button>
            <button
              className={styles.viewDetailsBtn}
              onClick={() => handleDeleteNote(record?.noteId)}
            >
              <DeleteIconRed style={{ height: "13px", width: "13px" }} />
            </button>
          </div>
        </Space>
      ),
    },
  ];

  return (
    <div className={styles.tableContainer}>
      <Spin spinning={isLoading || deleteNoteLoading}>
        <Table
          onChange={handlePagination}
          columns={columns}
          dataSource={notes}
          rowClassName={styles.row}
          className={styles.userListTable}
          sticky={true}
          style={{ minHeight: "80dvh" }}
          pagination={{
            position: ["bottomCenter"],
            pageSize: pageSize,
            current: currentPage,
          }}
        />
      </Spin>
    </div>
  );
};
